(() => {
  const initCarouselCursor = () => {
    document.querySelectorAll('.cv-carousel').forEach((carousel) => {
      const stage = carousel.querySelector('[data-slides]');

      if (!stage || stage.dataset.cvCursorReady === 'true') return;

      stage.dataset.cvCursorReady = 'true';
      stage.classList.add('cv-cursor-ready');

      const cursor = document.createElement('div');
      cursor.className = 'cv-carousel-cursor';
      cursor.setAttribute('aria-hidden', 'true');
      cursor.innerHTML = `
        <span class="cv-carousel-cursor__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M14.5 8L10.5 12L14.5 16"
              stroke="currentColor"
              stroke-width="2.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      `;

      document.body.appendChild(cursor);

      const hideCursor = () => {
        cursor.classList.remove(
          'is-visible',
          'is-left',
          'is-right'
        );
      };
      const syncCursorMode = () => {
        const rect = stage.getBoundingClientRect();

        if (rect.width <= 749) {
            hideCursor();
            cursor.style.display = 'none';
            stage.classList.remove('cv-cursor-ready');
        } else {
            cursor.style.display = '';
            stage.classList.add('cv-cursor-ready');
        }
        };

        syncCursorMode();

        window.addEventListener('resize', syncCursorMode);

        if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(syncCursorMode);
        observer.observe(stage);
}

     stage.addEventListener('pointermove', (event) => {
        const rect = stage.getBoundingClientRect();

        /* Disable custom cursor on mobile-sized carousel */
        if (event.pointerType === 'touch' || rect.width <= 749) {
            hideCursor();
            cursor.style.display = 'none';
            stage.classList.remove('cv-cursor-ready');
            return;
        }

        cursor.style.display = 'flex';

        stage.classList.add('cv-cursor-ready');

        if (
          event.target.closest(
            'a, button, input, select, textarea, [role="button"]'
          )
        ) {
          hideCursor();
          return;
        }


        const isLeft =
          event.clientX < rect.left + rect.width / 2;
         
        cursor.classList.toggle('is-left', isLeft);
        cursor.classList.toggle('is-right', !isLeft);

        cursor.style.left = `${event.clientX}px`;
        cursor.style.top = `${event.clientY}px`;
        cursor.style.display = 'flex';

        cursor.classList.add('is-visible');
      });

      stage.addEventListener('pointerleave', hideCursor);

      stage.addEventListener('click', (event) => {
      if (stage.getBoundingClientRect().width <= 749) return;
        if (
          event.target.closest(
            'a, button, input, select, textarea, [role="button"]'
          )
        ) {
          return;
        }

        const rect = stage.getBoundingClientRect();

        const isLeft =
          event.clientX < rect.left + rect.width / 2;

        const controls =
          carousel.querySelector('.cv-carousel-controls');

        if (!controls) return;

        let button;

        if (isLeft) {
          button = controls.querySelector(
            '[data-prev], [data-carousel-prev], [aria-label*="previous" i], [aria-label*="prev" i]'
          );
        } else {
          button = controls.querySelector(
            '[data-next], [data-carousel-next], [aria-label*="next" i]'
          );
        }

        if (!button) {
          const buttons = controls.querySelectorAll('button');

          button = isLeft
            ? buttons[0]
            : buttons[1];
        }

        if (button) {
          button.click();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initCarouselCursor
    );
  } else {
    initCarouselCursor();
  }

  document.addEventListener(
    'shopify:section:load',
    initCarouselCursor
  );
})();